module.exports = __webpack_public_path__ + "static/media/recent-blog1.4af59a9b.jpg";